module.exports = __webpack_public_path__ + "img/google.f863aef4.png";